<template>
  <layout>
    <page-header :header="$t('companies.applications')" />
    <div class="content">
      <admin-table ref="table" v-bind="tableProps"></admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import ApplicationApi from './ApplicationApi'

const resourceBase = 'company-applications'

export default {
  name: 'Companies',

  components: {
    AdminTable,
  },

  data() {
    return {
      res: 0,
      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder: () => {
          return new ApplicationApi()
        },
        sortBy: 'created_at',
        sortDesc: true,
        perPage: 9,
        columns: [
          {
            key: 'contact_name',
            label: this.$t('attributes.contact_name'),
            sortable: true,
          },
          {
            key: 'company_name',
            label: this.$t('companies.name'),
            sortable: true,
          },
          {
            key: 'email',
            label: this.$t('companies.email'),
          },
          {
            key: 'phone',
            label: this.$t('companies.phone'),
          },
          {
            key: 'created_at',
            label: this.$t('companies.created'),
            sortable: true,
            component: 'value-date',
            config: {
              stacked: true,
            },
          },
        ],

        // eslint-disable-next-line no-unused-vars
        rowActions: item => {
          let actions = []

          if (this.$allows('administer')) {
            actions.push('edit')
          }

          return actions
        },

        // define custom bulk actions
        bulkActions() {
          return []
        },
      },
    }
  },
}
</script>
